import React from 'react';
import styled from 'styled-components';
import { GoogleLogin, GoogleOAuthProvider, CredentialResponse } from '@react-oauth/google';

const GoogleButtonContainer = styled.div`
  width: 100%;
  
  > div {
    width: 100% !important;
  }

  button {
    width: 100% !important;
    height: 40px !important;
    border: 1px solid #dadce0 !important;
    background: white !important;
    border-radius: 4px !important;
    padding: 8px !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    cursor: pointer !important;
    transition: background-color 0.2s !important;

    &:hover {
      background: #f8f9fa !important;
    }

    &:active {
      background: #f1f3f4 !important;
    }

    div {
      width: 18px !important;
      height: 18px !important;
      padding: 0 !important;
      margin: 0 !important;
      margin-left: 6px !important;
    }

    span {
      font-family: "Roboto", "Google Sans", arial, sans-serif !important;
      font-size: 14px !important;
      color: #3c4043 !important;
      font-weight: 500 !important;
      letter-spacing: 0.25px !important;
      flex: 1 !important;
      text-align: center !important;
      padding-right: 24px !important;
    }
  }
`;

interface GoogleAuthButtonProps {
    onSuccess: (credentialResponse: CredentialResponse) => void;
    text?: 'signin_with' | 'signup_with' | 'continue_with' | 'signin';
}

const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({ onSuccess, text = 'signin_with' }) => {
    return (
        <GoogleOAuthProvider clientId="753369775438-0t7k7qp4bp0i6n0jjftg5p1rrq4aae99.apps.googleusercontent.com">
            <GoogleButtonContainer>
                <GoogleLogin
                    onSuccess={onSuccess}
                    onError={() => console.log('Login Failed')}
                    useOneTap
                    type="standard"
                    theme="outline"
                    size="large"
                    text={text}
                    shape="rectangular"
                    width="100%"
                    locale="en"
                />
            </GoogleButtonContainer>
        </GoogleOAuthProvider>
    );
};

export default GoogleAuthButton; 